import { array, struct } from 'io-ts/Decoder';

import { Dimension } from '../../../../../whole-house/bom/quantity-aggregation/Dimension';

export const Request = struct({
	/**
	 * The dimensions to aggregate this transaction's BoM by, replacing whatever it uses now.
	 *
	 * A flat list, mirroring the organisation configuration — `takeOffId` is itself a dimension,
	 * so a take-off is something the BoM is aggregated *by*, not an axis it is configured *per*.
	 * Order is not significant: the same set defines the same aggregation however it is listed.
	 */
	aggregateBy: array(Dimension),
});
